// Centralized data-testid constants for Wishire landing page
export const NAV = {
  logo: "nav-logo",
  candidates: "nav-link-candidates",
  companies: "nav-link-companies",
  score: "nav-link-score",
  pricing: "nav-link-pricing",
  waitlistCta: "nav-cta-waitlist",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  candidateCta: "hero-cta-candidate",
  companyCta: "hero-cta-company",
  scoreCard: "hero-score-card",
};

export const WAITLIST = {
  emailInput: "waitlist-email-input",
  nameInput: "waitlist-name-input",
  roleCandidate: "waitlist-role-candidate",
  roleCompany: "waitlist-role-company",
  submit: "waitlist-submit",
  success: "waitlist-success",
  error: "waitlist-error",
};

export const TABS = {
  howCandidate: "how-tab-candidate",
  howCompany: "how-tab-company",
  pricingCandidate: "pricing-tab-candidate",
  pricingCompany: "pricing-tab-company",
};

export const DEMO = {
  micToggle: "demo-mic-toggle",
  questionNext: "demo-question-next",
  scoreReveal: "demo-score-reveal",
};

export const FAQ = (i) => `faq-item-${i}`;
export const FOOTER = {
  email: "footer-waitlist-email",
  submit: "footer-waitlist-submit",
};
